"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    title: 'Precisa de ajuda?',
    content: 'Caso não tenha acesso ao seu celular ##helpCenter##',
    links: [
        {
            token: '##helpCenter##',
            content: 'entre em contato com nossa Central de Ajuda',
            link: {
                title: 'Entre em contato com a nossa Central de Ajuda',
                href: 'https://meucatalogodigitalresources.grupoboticario.digital/assets/pdfs/termos-de-uso.pdf',
                target: '_blank',
            },
        },
    ],
};
